export default __webpack_public_path__ + "static/media/Map3-1.cf0e4d3b.png";